const CheckCircleIcon = ({ fillColor, ...props }: any) => (
	<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect width={24} height={24} />
		<circle cx={12} cy={12} r={11.5} fill={fillColor || "#3F7EAB"} stroke="#437CA6" />
		<g clipPath="url(#clip0_1773_13561)">
			<path
				d="M10.3329 16.1662C10.1119 16.1661 9.89994 16.0783 9.74369 15.922L7.24369 13.422C7.09189 13.2648 7.0079 13.0543 7.0098 12.8358C7.0117 12.6173 7.09934 12.4083 7.25384 12.2538C7.40835 12.0993 7.61736 12.0117 7.83586 12.0098C8.05436 12.0079 8.26486 12.0919 8.42203 12.2437L10.2554 14.077L15.5079 7.32115C15.6436 7.14655 15.8431 7.03301 16.0625 7.0055C16.2819 6.978 16.5033 7.03878 16.6779 7.17448C16.8525 7.31019 16.966 7.50969 16.9935 7.72911C17.021 7.94853 16.9602 8.16988 16.8245 8.34448L10.9912 15.8445C10.9187 15.9381 10.8271 16.0152 10.7225 16.0707C10.6179 16.1262 10.5027 16.1587 10.3845 16.1662H10.3329Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1773_13561">
				<rect width={10} height={10} fill="white" transform="translate(7 7)" />
			</clipPath>
		</defs>
	</svg>
);
export default CheckCircleIcon;
